import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import Ring from './Ring.js';
import { Root } from './Logo.styles.js';
import { VIEW_BOX_SIZE, NUMBER_OF_RINGS, BASE_RADIUS, STROKE_WIDTH } from './Logo.contants.js';

var _excluded = ["animate", "colour", "id"];
var Logo = function Logo(_ref) {
  var _ref$animate = _ref.animate,
    animate = _ref$animate === void 0 ? false : _ref$animate,
    colour = _ref.colour,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'sb-logo' : _ref$id,
    svgProps = _objectWithoutProperties(_ref, _excluded);
  return React__default.createElement(Root, _extends({}, svgProps, {
    id: id,
    viewBox: "0 0 ".concat(VIEW_BOX_SIZE, " ").concat(VIEW_BOX_SIZE)
  }), Array(NUMBER_OF_RINGS).fill(0).map(function (_, index) {
    var key = "".concat(id, "-").concat(index);
    return React__default.createElement(Ring, {
      animate: animate,
      colour: colour,
      id: key,
      key: key,
      radius: BASE_RADIUS - STROKE_WIDTH * index
    });
  }));
};
Logo.propTypes = {
  animate: PropTypes.bool,
  colour: PropTypes.string.isRequired,
  id: PropTypes.string
};
var Logo$1 = Logo;

export { Logo$1 as default };
//# sourceMappingURL=Logo.js.map
